'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants');

/**
 * Get required device information for the merchant
 * @return {object} browserInfo
 */
var gatherBrowserData = function gatherBrowserData() {
  return {
    browserLanguage: navigator.language,
    browserScreenHeight: window.innerHeight,
    browserScreenWidth: window.innerWidth,
    browserTimezone: new Date().getTimezoneOffset(),
    browserUserAgent: navigator.userAgent,
    browserColorDepth: window.screen.colorDepth,
    browserJavaEnabled: navigator.javaEnabled && navigator.javaEnabled(),
    // By default is true
    browserJavaScriptEnabled: true,
    challengeWindowSize: _constants.CHALLENGE_WINDOW_SIZE_250X400
  };
};

exports.default = gatherBrowserData;